import type { ReactNode } from "react";
import {
  PDF_QUOTATION_PAGE_SHELL_CLASS,
  PDF_QUOTATION_PAGE_SHELL_STYLE,
} from "@/lib/proposalPdfQuotationLayout";

type Props = {
  children: ReactNode;
  testId?: string;
  className?: string;
  /** Cover may fill the full A4 box without internal padding (hero bleed). */
  fullBleed?: boolean;
};

/**
 * Fixed A4 quotation page shell with explicit print margins.
 * Used by Summary / Option / Terms / Closing (and pagination-created pages via applyPdfQuotationPageShellStyles).
 */
export default function DtoolsPdfQuotationPageShell({
  children,
  testId,
  className = "",
  fullBleed = false,
}: Props) {
  return (
    <div
      className={`${PDF_QUOTATION_PAGE_SHELL_CLASS} ${className}`.trim()}
      data-testid={testId}
      data-pdf-quotation-shell="true"
      style={
        fullBleed
          ? {
              ...PDF_QUOTATION_PAGE_SHELL_STYLE,
              padding: 0,
              overflow: "hidden",
            }
          : PDF_QUOTATION_PAGE_SHELL_STYLE
      }
    >
      {children}
    </div>
  );
}
